'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

function _interopExportWildcard(obj, defaults) { var newObj = defaults({}, obj); delete newObj['default']; return newObj; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _dalError = require('./dal-error');

_defaults(exports, _interopExportWildcard(_dalError, _defaults));

var DAL = (function () {
  function DAL(client, endpoints) {
    _classCallCheck(this, DAL);

    if (!client) {
      throw new Error('No client provided');
    }

    if (!endpoints || !Object.keys(endpoints).length) {
      throw new Error('No endpoints provided');
    }

    this._client = client;
    this.incorporateEndpoints(endpoints);
    this.exposeClientMethods({
      setToken: 'useToken',
      setHeader: 'setHeader'
    });
  }

  _createClass(DAL, [{
    key: 'isUsingUnauthenticatedToken',
    value: function isUsingUnauthenticatedToken() {
      return this.unauthenticatedToken === this._client.getToken();
    }
  }, {
    key: 'setUnauthenticatedToken',
    value: function setUnauthenticatedToken(token) {
      this.unauthenticatedToken = token;
    }
  }, {
    key: 'useUnauthenticatedToken',
    value: function useUnauthenticatedToken() {
      if (!this.unauthenticatedToken) {
        throw new Error('No unauthenticated token provided');
      }
      this.useToken(this.unauthenticatedToken);
    }
  }, {
    key: 'exposeClientMethods',
    value: function exposeClientMethods(methods) {
      var _this = this;

      Object.keys(methods).forEach(function (clientMethodName) {
        if (_this._client[clientMethodName]) {
          _this[methods[clientMethodName]] = _this._client[clientMethodName].bind(_this._client);
        }
      });
    }
  }, {
    key: 'onError',
    value: function onError(error) {
      if (!this.errorHandler) {
        throw error;
      } else {
        return this.errorHandler(error);
      }
    }
  }, {
    key: 'checkForErrors',
    value: function checkForErrors(response) {
      if (response && Object.keys(response).indexOf('success') !== -1 && !response.success) {
        throw new Error('response failed');
      } else {
        return response;
      }
    }
  }, {
    key: 'substituteUrl',
    value: function substituteUrl(pattern, args) {
      var argIdx = 0;
      return {
        substitutedUrl: pattern.replace(/\$\d+/g, function () {
          return args[argIdx++];
        }),
        params: args[argIdx],
        overrides: args[argIdx + 1]
      };
    }
  }, {
    key: 'doRequest',
    value: function doRequest(method, objPath, urlPattern) {
      for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
        args[_key - 3] = arguments[_key];
      }

      var _substituteUrl = this.substituteUrl(urlPattern, args);

      var params = _substituteUrl.params;
      var overrides = _substituteUrl.overrides;
      var substitutedUrl = _substituteUrl.substitutedUrl;

      return this._client[method.toLowerCase()](substitutedUrl, params, overrides, objPath).then(this.checkForErrors.bind(this))['catch'](this.onError.bind(this));
    }
  }, {
    key: 'doDebugRequest',
    value: function doDebugRequest(method, objPath, urlPattern) {
      for (var _len2 = arguments.length, args = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
        args[_key2 - 3] = arguments[_key2];
      }

      console.log.apply(console, ['Making ' + method + ' call to ' + urlPattern + ' with'].concat(args)); // eslint-disable-line no-console
      return this.doRequest.apply(this, [method, objPath, urlPattern].concat(args)).then(function (response) {
        console.log('SUCCESS', JSON.stringify(response, null, '  ')); // eslint-disable-line no-console
        return response;
      })['catch'](function (err) {
        console.log('ERROR', err); // eslint-disable-line no-console
        throw err;
      });
    }
  }, {
    key: 'incorporateEndpoints',
    value: function incorporateEndpoints(endpoints) {
      var _this2 = this;

      Object.keys(endpoints).forEach(function (objPath) {
        var parts = objPath.split('.');
        var on = parts.slice(0, parts.length - 1).reduce(function (memo, key) {
          if (!memo[key]) {
            memo[key] = {};
          }
          return memo[key];
        }, _this2);

        var _endpoints$objPath = _slicedToArray(endpoints[objPath], 2);

        var method = _endpoints$objPath[0];
        var urlPattern = _endpoints$objPath[1];

        on[parts[parts.length - 1]] = _this2.doRequest.bind(_this2, method, objPath, urlPattern);
        on['_' + parts[parts.length - 1]] = _this2.doDebugRequest.bind(_this2, method, objPath, urlPattern);
      });
    }
  }]);

  return DAL;
})();

exports['default'] = DAL;